import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoggerService } from 'src/app/core/logger/logger.service';

import { GeneralService } from 'src/app/shared/services/general.service';
import { AbstractForm } from '../../utils/abstract-form';

@Component({
    selector: 'reason.component',
    templateUrl: './reason.component.html',
    styleUrls: ['./reason.component.scss'],
})
export class ReasonComponent extends AbstractForm implements OnInit {

    placeholder = 'Digite um motivo';
    title = 'Digite um motivo';
    readonly = false;

    subtitle = false;
    sendButton = true;
    max = 60;
    min = 0;
    mask:any = false;
    type = 'input';
    sendTitle = 'Enviar';
    closeTitle = 'Cancelar';
    reasonText = '';
    
    init = false;
    @ViewChild('reason', { static: false }) reason: ElementRef;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data,
        public dialog: MatDialog,
        protected gs: GeneralService,
        logger: LoggerService,
        protected formBuilder: FormBuilder
    ) {
        super(formBuilder, logger,false);
    }

    buildFormGroup(): FormGroup {
        return this.formBuilder.group({
            reason: ['', this.data?.validators || []]
        });

    }

    updateControls() { }
    updateObject(): any { }

    ngOnInit() {

        if(this.data?.title)
            this.title = this.data.title;

        if(this.data?.subtitle)
            this.subtitle = this.data.subtitle;

        if(this.data?.placeholder)
            this.placeholder = this.data.placeholder;

        if(this.data?.max)
            this.max = this.data.max;
            
        if(this.data?.mask)
            this.mask = this.data.mask;

        if(this.data?.min)
            this.min = this.data.min;

        if(this.data?.type)
            this.type = this.data.type;

        if(this.data?.sendTitle)
            this.sendTitle = this.data.sendTitle;

        if(this.data?.sendTitle)
            this.closeTitle = this.data.closeTitle;

        if(this.data?.sendButton == false)
            this.sendButton = false;

        if(this.data?.readonly)
            this.readonly = true;
            
        this.init = true;

        this.formDefault();

        if(this.data?.reason){
            this.reasonText = this.data.reason;
            this.formGroup.controls.reason.setValue(this.data.reason);
        }

        setTimeout(() => this.reason.nativeElement.focus(), 100);

    }

    send() {
        let values = this.getFormValues();

        if(values.reason.toString().length >= this.min && values.reason.toString().length <= this.max)
            this.dialog.getDialogById(this.data.modalId).close(values);
        else
            this.gs.error(false,'Preencha o campo corretamente'); 
    }
}